import React from 'react';
import { TextLinkLayoutProps } from 'ui-builder';
import useFeatureToggleService from 'feature-toggle';
import ShadcnTextLinkLayout from './ShadcnTextLinkLayout';

function LegacyTextLinkLayout(props: TextLinkLayoutProps) {
  return (
    <a
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        props.onClick?.();

        if (!props.onClick) {
          window.open(props.href, props.target || '_self');
        }
      }}
      href={props.href}
      className={props.className}
      title={props.title}
      data-testid={props.testId}
    >
      {props.children}
    </a>
  );
}

export default function TextLinkLayout(props: TextLinkLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnTextLinkLayout {...props} />;
  } else {
    return <LegacyTextLinkLayout {...props} />;
  }
}
